import React from 'react';
import Icon from '../../../components/AppIcon';

const ErrorRateCard = ({ title, value, rate, subtitle, trend, icon, color }) => {
  const getColorClasses = (color) => {
    switch (color) {
      case 'red':
        return {
          bg: 'bg-red-50',
          border: 'border-red-200',
          icon: 'text-red-600',
          text: 'text-red-900'
        };
      case 'orange':
        return {
          bg: 'bg-orange-50',
          border: 'border-orange-200',
          icon: 'text-orange-600',
          text: 'text-orange-900'
        };
      case 'yellow':
        return {
          bg: 'bg-yellow-50',
          border: 'border-yellow-200',
          icon: 'text-yellow-600',
          text: 'text-yellow-900'
        };
      case 'blue':
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          icon: 'text-blue-600',
          text: 'text-blue-900'
        };
      default:
        return {
          bg: 'bg-gray-50',
          border: 'border-gray-200',
          icon: 'text-gray-600',
          text: 'text-gray-900'
        };
    }
  };

  const colors = getColorClasses(color);
  const trendIsPositive = trend > 0;

  return (
    <div className={`${colors?.bg} border ${colors?.border} rounded-xl p-4`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name={icon} size={20} strokeWidth={2} className={colors?.icon} />
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        {trend !== 0 && (
          <div className={`flex items-center gap-1 text-xs ${
            trendIsPositive ? 'text-red-600' : 'text-green-600'
          }`}>
            <Icon 
              name={trendIsPositive ? 'TrendingUp' : 'TrendingDown'} 
              size={14} 
              strokeWidth={2} 
            />
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <div className="mb-1">
        <p className={`text-3xl font-heading font-bold ${colors?.text}`}>
          {value?.toLocaleString()}
        </p>
      </div>
      {rate && (
        <p className="text-sm text-muted-foreground">{rate}</p>
      )}
      {subtitle && (
        <p className="text-sm text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default ErrorRateCard;